const throttle = (f, t, _caller) => {
    return args => {
        let previousCall = _caller.lastCall;
        _caller.lastCall = Date.now();
        _caller.needCall = true;
        if (
            _caller.needCall ||
            previousCall === undefined || // function is being called for the first time
            _caller.lastCall - previousCall > t
        ) {
            // throttle time has elapsed
            _caller.needCall = false;
            f(args);
        }
    };
};

export const throttle2 = (func, delay) => {
    let lastCall = 0;

    return (...args) => {
        const now = Date.now();
        if (now - lastCall > delay) {
            lastCall = now;
            func(...args);
        }
    };
};

export default throttle;
